import { apiAuth, apiNoAuth } from "./conection";

export const webSiteReviewsService = {
  async createReview(rating, comment) {
    console.log("=== Iniciando createReview ===");
    console.log("Dados da requisição:", { rating, comment });
    console.log("URL base:", apiAuth.defaults.baseURL);
    console.log("Headers:", apiAuth.defaults.headers);

    try {
      const response = await apiAuth.post("/web/site/review/", {
        rating,
        comment,
      });

      console.log("Resposta recebida:", response);
      return response.data;
    } catch (error) {
      console.error("=== Erro detalhado no createReview ===");
      console.error("Status do erro:", error.response?.status);
      console.error("Dados do erro:", error.response?.data);
      console.error("Mensagem do erro:", error.message);
      console.error("Erro completo:", error);
      throw error;
    }
  },

  async getAllReviews() {
    try {
      const response = await apiNoAuth.get("/web/site/review/");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
